<template>
  <EditCom
    :title="title"
    :target="target"
    :buttonList="buttonList"
    :inputList="inputList"
    :rules="rules"
    @closeFun="close"
  ></EditCom>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, reactive,
} from 'vue';
import { isNull, dayjs, message } from '@/utils/js/initVariable';
import EditCom from '@/components/EditCom';

import { moveAnnotation } from '@/api/UserWorkspaceDataApi';

// props
const props = defineProps({
  baseTarget: { type: Object },
  target: { type: Object, },
  title: { type: String, },
});
// emit
const emit = defineEmits([
  'close',
]);

const close = ()=>{
  emit('close');
}

const submitFn = (item, button, loadFn, fn)=>{
  moveAnnotation({
    oldBizId: item['id'],
    newBizId: item['baseId'],
    bizType: 1,
  }).then(res=>{
    if(res.data.code == 1004){
      close();
      message(res.data.msg, 1);
    }
    loadFn && loadFn();
  }).catch(err=>{
    loadFn && loadFn();
    console.log(err);
  });
}
const submit = (form, item, button, loadFn, fn)=>{
  // console.log(form, item, button, loadFn, fn);
  form.value.validate((valid)=>{
    // console.log(valid);
    if(valid){
      submitFn(item, button, loadFn, fn);
    }else{
      loadFn && loadFn();
    }
  });
};

const buttonList = ref([
  { name: '取消', fun: close, type: 'danger', },
  { name: '确定', fun: submit, type: 'primary', },
]);
const inputList = ref([
  { name: '底图', prop: 'baseId', type: 'select',
    select: {
      list: 'baseList',
      label: 'name',
      value: 'id',
      filterable: true,
    }
  },
]);
const rules = reactive({
  baseId: [
    { required: true, message: '请选择底图', trigger: 'blur' },
  ],
  // exportName: [
  //   { required: true, message: '请输入文件名称', trigger: 'blur' },
  // ],
});

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{
  
});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{

});

</script>

<style lang='less'>

</style>

<style lang='less' scoped>

</style>